import { Checkbox, IconButton, Menu, MenuItem } from "@mui/material";
import React, { useState, useEffect } from "react";
import { OptionsMenuIcon } from "./utils/InsyncIconsUtil";
import { SmallHeader } from "./Typography";

export default function OptionMenu({
  options,
  button = null,
  zIndex = 21474833, // increase this value if using inside sidebar
  enableCheckBoxes = false,
  title = null,
  customStyle = {},
}) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [localOptions, setLocalOptions] = useState(options);

  // Update local options when props change
  useEffect(() => {
    setLocalOptions(options);
  }, [options]);

  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const clonedButton = button ? (
    React.cloneElement(button, { onClick: handleClick })
  ) : (
    <IconButton
      aria-label="more"
      id="long-button"
      aria-controls={open ? "long-menu" : undefined}
      aria-expanded={open ? "true" : undefined}
      aria-haspopup="true"
      onClick={handleClick}
    >
      <OptionsMenuIcon />
    </IconButton>
  );

  const handleMenuItemClick = (index, option) => {
    // Don't close the menu when clicking on a checkbox item
    // This allows users to select multiple options without reopening the menu
    if (enableCheckBoxes && !option.isHeader) {
      if (typeof option.onClick === "function") {
        option.onClick();
      }
    } else {
      // For non-checkbox items, close the menu after clicking
      handleClose();
      if (typeof option.onClick === "function") {
        option.onClick();
      }
    }
  };

  return (
    <div>
      {clonedButton}
      <Menu
        id="long-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        sx={{
          zIndex: zIndex,
        }}
        PaperProps={{
          style: {
            width: "20ch",
            zIndex: zIndex,
            ...customStyle,
          },
        }}
        MenuListProps={{
          dense: true,
          disablePadding: true
        }}
      >
        {title && (
          <SmallHeader style={{ margin: "4px 10px" }}>{title}</SmallHeader>
        )}
        {localOptions.map((option, index) => {
          // Check if this is a header item
          if (option.isHeader) {
            return (
              <div 
                key={`header-${index}`}
                style={{ 
                  padding: "8px 16px", 
                  fontWeight: "bold", 
                  backgroundColor: "#f5f5f5",
                  borderBottom: "1px solid #e0e0e0"
                }}
              >
                {option.title}
              </div>
            );
          }
          
          // Regular menu item
          return (
            <MenuItem
              key={option.value || `option-${index}`}
              onClick={(e) => {
                // Call the onClick handler directly
                if (typeof option.onClick === "function") {
                  option.onClick();
                }
              }}
              disabled={option.disabled}
            >
              {enableCheckBoxes && !option.isHeader && (
                <Checkbox 
                  checked={option.selected || false}
                  onChange={(e) => {
                    // Prevent default to avoid menu closing
                    e.stopPropagation();
                  }}
                />
              )}{" "}
              <span>{option.title}</span>
            </MenuItem>
          );
        })}
      </Menu>
    </div>
  );
}
